import { Component, Input, OnInit } from '@angular/core';
import { BalanceDataModel, BalanceItemPaymentStatus } from '../../models/liability-data.model';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-balance-info',
  templateUrl: './balance-info.component.html',
  styleUrls: ['./balance-info.component.scss'],
  animations: [
    trigger('drawerExpand', [
      transition(':enter', [style({ maxHeight: 0 }), animate('150ms', style({ maxHeight: '8rem' }))]),
      transition(':leave', [animate('150ms', style({ maxHeight: 0 }))])
    ])
  ]
})
export class BalanceInfoComponent implements OnInit {
  BalanceItemPaymentStatus = BalanceItemPaymentStatus;
  @Input() balance: BalanceDataModel;
  expanded = false;

  constructor() {}

  ngOnInit(): void {}

  toggleExpanded() {
    this.expanded = !this.expanded;
  }
}
